// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--32D5N","header":"section-module--header--2xD3a"};